import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const FETCH = 'lastDayOfMonth/FETCH';
const FETCH_SUCCESS = 'lastDayOfMonth/FETCH_SUCCESS';
const FETCH_FAIL = 'lastDayOfMonth/FETCH_FAIL';

const initialState = {
  lastDayOfMonth: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        lastDayOfMonth: action.result.data
      };
    case FETCH_FAIL:
      return {
        ...state,
        error: action.error.data
      };
    default:
      return state;
  }
}

export function fetchLastDayOfMonth(month, year) {
  return {
    types: [FETCH, FETCH_SUCCESS, FETCH_FAIL],
    promise: client => client.post(`/lastDayOfMonth?month=${month}&year=${year}`, { data: {} })
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/lastDayOfMonth.js